/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SearchSubRuleQuery
 */
export interface SearchSubRuleQuery {
    /**
     * 
     * @type {string}
     * @memberof SearchSubRuleQuery
     */
    ruleId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SearchSubRuleQuery
     */
    showDisabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SearchSubRuleQuery
     */
    showDeleted?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SearchSubRuleQuery
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchSubRuleQuery
     */
    details?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchSubRuleQuery
     */
    supplier?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchSubRuleQuery
     */
    carrier?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SearchSubRuleQuery
     */
    offset?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SearchSubRuleQuery
     */
    limit?: number | null;
}

export function SearchSubRuleQueryFromJSON(json: any): SearchSubRuleQuery {
    return SearchSubRuleQueryFromJSONTyped(json, false);
}

export function SearchSubRuleQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchSubRuleQuery {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ruleId': !exists(json, 'ruleId') ? undefined : json['ruleId'],
        'showDisabled': !exists(json, 'showDisabled') ? undefined : json['showDisabled'],
        'showDeleted': !exists(json, 'showDeleted') ? undefined : json['showDeleted'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'details': !exists(json, 'details') ? undefined : json['details'],
        'supplier': !exists(json, 'supplier') ? undefined : json['supplier'],
        'carrier': !exists(json, 'carrier') ? undefined : json['carrier'],
        'offset': !exists(json, 'offset') ? undefined : json['offset'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
    };
}

export function SearchSubRuleQueryToJSON(value?: SearchSubRuleQuery | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ruleId': value.ruleId,
        'showDisabled': value.showDisabled,
        'showDeleted': value.showDeleted,
        'description': value.description,
        'details': value.details,
        'supplier': value.supplier,
        'carrier': value.carrier,
        'offset': value.offset,
        'limit': value.limit,
    };
}


